import PitchResult from '../PitchResult.js';

const PitchResultGroup = {
    all: {
        key: 'all', 
        name: 'All',
        results: Object.values(PitchResult).map( value => value.key )
    },
    hits: { key: 'hits', name: 'Base hits', results: [
        PitchResult.Single.key, PitchResult.Double.key,
        PitchResult.Triple.key, PitchResult.HomeRun.key,
    ]},
    balls: { key: 'balls', name: 'All balls', results: [
        PitchResult.Ball.key, PitchResult.IntentionalBall.key,
        PitchResult.HitByPitch.key,
    ]},
    swings: { key: 'swings', name: 'Swing', results: [
        PitchResult.StrikeoutSwinging.key, PitchResult.SwingingStrike.key,
        PitchResult.Single.key, PitchResult.Double.key, PitchResult.Triple.key, PitchResult.HomeRun.key,
        PitchResult.ContactOut.key, PitchResult.FoulBall.key, PitchResult.Error.key
    ]},
    whiffs: { key: 'whiffs', name: 'Whiff', results: [
        PitchResult.StrikeoutSwinging.key, PitchResult.SwingingStrike.key
    ]},
    contacts: { key: 'contacts', name: 'Contact', results: [
        PitchResult.Single.key, PitchResult.Double.key, PitchResult.Triple.key, PitchResult.HomeRun.key,
        PitchResult.ContactOut.key, PitchResult.FoulBall.key, PitchResult.Error.key
    ]},
    strikes: { key: 'strikes', name: 'All strikes', results: [
        PitchResult.Single.key, PitchResult.Double.key,
        PitchResult.Triple.key, PitchResult.HomeRun.key,
        PitchResult.ContactOut.key, PitchResult.Error.key,
        PitchResult.CalledStrike.key, PitchResult.SwingingStrike.key,
        PitchResult.StrikeoutLooking.key, PitchResult.StrikeoutSwinging.key,
    ]},
    strikeouts: { key: 'strikeouts', name: 'Strikeouts', results: [
        PitchResult.StrikeoutLooking.key, PitchResult.StrikeoutSwinging.key
    ]},
    outs: { key: 'outs', name: 'All outs', results: [
        PitchResult.StrikeoutLooking.key, PitchResult.StrikeoutSwinging.key,
        PitchResult.ContactOut.key
    ]},
    fair: { key: 'fair', name: 'Fair balls', results: [
        PitchResult.Single.key, PitchResult.Double.key, PitchResult.Triple.key,
        PitchResult.HomeRun.key, PitchResult.ContactOut.key, PitchResult.Error.key,
    ]},
    other: { key: 'other', name: 'Other', results: [
        PitchResult.FoulBall.key, PitchResult.Unidentified.key, PitchResult.Walk.key
    ]}
    // from ACG
    //'ac': { key: 'ac', name: 'All Contact', results: ['SE', 'DE', 'TE', 'HR', 'FB']},
    //'cno': { key: 'cno', name: 'Contact, No Out', results: ['SE', 'DE', 'TE', 'HR']},
    //'co': { key: 'co', name: 'Contact Outs', results: ['CO']},
    //'ncs': { key: 'ncs', name: 'Non-contact Strikes', results: ['CS', 'SS', 'SSO', 'CSO']},
    //'ss': { key: 'ss', name: 'Swinging Strikes', results: ['SS']},
    //'cs': { key: 'cs', name: 'Called Strikes', results: ['CS']},
    //'ab': { key: 'ab', name: 'All Balls', results: ['B', 'IB', 'HP']},
    //'ao': { key: 'ao', name: 'All Outs', results: ['CO', 'SSO', 'CSO']},
    //'fb': { key: 'fb', name: 'Foul Balls', results: ['FB']},
    //'hbp': { key: 'hbp', ame: 'Hit By Pitch', results: ['HP']}
};

export default PitchResultGroup;